import styled from 'styled-components';
import { key } from 'styled-theme';
import { elementSize, media } from '@sizeid/commons/utils/styles';

const arrowSize = 48;

export default styled.span<{ next?: boolean }>`
  ${elementSize(arrowSize)};
  border: 1px solid ${key('global.primary')};
  border-radius: 100%;
  color: ${key('global.primary')};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: absolute;
  top: 50%;
  margin-top: -${arrowSize / 2}px;
  ${props => (props.next ? 'right' : 'left')}: 0px;
  z-index: 99;

  ${media.lessThan('sm')`
    display: none;
  `};
`;
